module.exports = __webpack_public_path__ + "static/media/Image-Values3.f5970d6b.png";